"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectPendingCleanupQueueLength = exports.selectCurrentCleaningUpLength = exports.selectCleanupQueue = exports.selectCurrentCleaningUp = exports.selectCleanupQueueLength = exports.selectNextMediafileIdToCleanup = exports.selectMediafileDownloadDelay = exports.selectMediafileQueuePendingLength = exports.selectCurrentDownloadingMediafilesLength = exports.selectNextMediafileIdToDownload = exports.selectActualDelayedMediafiles = exports.selectDelayedMediafileIds = exports.selectMediafileDownloadQueueLength = exports.selectCurrentDownloadingMediafiles = exports.selectMediafileDownloadQueue = void 0;
function selectMediafileDownloadQueue(state) {
    return state.mediafilesMeta.mediafileDownloadQueue;
}
exports.selectMediafileDownloadQueue = selectMediafileDownloadQueue;
function selectCurrentDownloadingMediafiles(state) {
    return state.mediafilesMeta.currentDownloading;
}
exports.selectCurrentDownloadingMediafiles = selectCurrentDownloadingMediafiles;
function selectMediafileDownloadQueueLength(state) {
    return state.mediafilesMeta.mediafileDownloadQueue.length;
}
exports.selectMediafileDownloadQueueLength = selectMediafileDownloadQueueLength;
function selectDelayedMediafileIds(state) {
    return Object.keys(state.mediafilesMeta.mediafileDownloadDelays).map(function (id) { return Number(id); });
}
exports.selectDelayedMediafileIds = selectDelayedMediafileIds;
function selectActualDelayedMediafiles(state) {
    var delays = Object.entries(state.mediafilesMeta.mediafileDownloadDelays);
    return delays
        .filter(function (_a) {
        var _b = __read(_a, 2), _ = _b[0], delay = _b[1];
        return Date.now() < delay.delay;
    })
        .map(function (_a) {
        var _b = __read(_a, 2), id = _b[0], _ = _b[1];
        return Number(id);
    });
}
exports.selectActualDelayedMediafiles = selectActualDelayedMediafiles;
function selectNextMediafileIdToDownload(state) {
    var queue = selectMediafileDownloadQueue(state);
    var current = new Set(selectCurrentDownloadingMediafiles(state));
    var delays = new Set(selectActualDelayedMediafiles(state));
    return queue.filter(function (mediafileId) { return !current.has(mediafileId) && !delays.has(mediafileId); })[0];
}
exports.selectNextMediafileIdToDownload = selectNextMediafileIdToDownload;
function selectCurrentDownloadingMediafilesLength(state) {
    var _a, _b;
    return (_b = (_a = selectCurrentDownloadingMediafiles(state)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : [];
}
exports.selectCurrentDownloadingMediafilesLength = selectCurrentDownloadingMediafilesLength;
function selectMediafileQueuePendingLength(state) {
    var queued = selectMediafileDownloadQueueLength(state);
    var downloading = selectCurrentDownloadingMediafilesLength(state);
    return downloading > queued ? 0 : queued - downloading;
}
exports.selectMediafileQueuePendingLength = selectMediafileQueuePendingLength;
function selectMediafileDownloadDelay(state, mediafileId) {
    return state.mediafilesMeta.mediafileDownloadDelays[mediafileId];
}
exports.selectMediafileDownloadDelay = selectMediafileDownloadDelay;
function selectNextMediafileIdToCleanup(state) {
    var queue = state.mediafilesMeta.mediafileCleanupQueue;
    var current = new Set(Object.keys(state.mediafilesMeta.currentCleaningUp));
    return Object.values(queue).filter(function (item) { return !current.has(String(item.id)); })[0];
}
exports.selectNextMediafileIdToCleanup = selectNextMediafileIdToCleanup;
function selectCleanupQueueLength(state) {
    return Object.keys(state.mediafilesMeta.mediafileCleanupQueue).length;
}
exports.selectCleanupQueueLength = selectCleanupQueueLength;
function selectCurrentCleaningUp(state) {
    return Object.values(state.mediafilesMeta.currentCleaningUp);
}
exports.selectCurrentCleaningUp = selectCurrentCleaningUp;
function selectCleanupQueue(state) {
    return state.mediafilesMeta.mediafileCleanupQueue;
}
exports.selectCleanupQueue = selectCleanupQueue;
function selectCurrentCleaningUpLength(state) {
    return selectCurrentCleaningUp(state).length;
}
exports.selectCurrentCleaningUpLength = selectCurrentCleaningUpLength;
function selectPendingCleanupQueueLength(state) {
    var cleanup = Object.values(selectCleanupQueue(state));
    var current = new Set(Object.keys(selectCurrentCleaningUp(state)));
    return cleanup.filter(function (item) { return !current.has(String(item.id)); }).length;
}
exports.selectPendingCleanupQueueLength = selectPendingCleanupQueueLength;
//# sourceMappingURL=mediafilesMeta.js.map